module.exports = __webpack_public_path__ + "img/pn.0baace9e.svg";